// character
export const SPEED = 16
